export enum TraceType {
    PageLoad = "PageLoad",
    PageInitialLoad = "PageInitialLoad",
    ErrorPage = "ErrorPage",
    BtnClick = "BtnClick",
    InitTransaction = "InitTransaction",
    InitTransactionSalesPage = "InitTransactionSalesPage",
    InitPedTransactionSalesPage = "InitPedTransactionSalesPage",
    ScheduleSmsReminder = "ScheduleSmsReminder",
    PlayVideo = "PlayVideo",
    RequestSend = "RequestSend",
    Redirect = "Redirect",
    Error = "Error",
    SolvedQuiz = "SolvedQuiz",
    CookieConsent = "CookieConsent",
    Experiment = "Experiment",
    ScheduledSalesCall = "ScheduledSalesCall",
    CalendlyAction = "CalendlyAction",
    CalendlyEventTypeViewed = "CalendlyEventTypeViewed",
    CalendlyDateAndTimeSelected = "CalendlyDateAndTimeSelected",
    CalendlyEventScheduled = "CalendlyEventScheduled",
    QrCodeScan = "QrCodeScan",
    SalesPageLoad = "SalesPageLoad",
    PedSalesPageLoad = "PedSalesPageLoad",
    WebinarLinkClick = "WebinarLinkClick",
    RegistrationComplete = "RegistrationComplete",
    SubmitRegistration = "SubmitRegistration",
    EbookDownloaded = "EbookDownloaded",
    ClickApplyFor1v1 = "ClickApplyFor1v1",
    PowerMapDownloaded = "PowerMapDownloaded",
    WebinarInitialQuizSubmitted = "WebinarInitialQuizSubmitted",
    EnteredEmail = "EnteredEmail",
    EbookWebinarUpsell = "EbookWebinarUpsell",
    SmsLinkClick = "SmsLinkClick",
}

export interface Trace {
    sessionId: string
    origin: string,
    searchParams: string,
    pathname: string,
    href: string,
    timestamp: string,
    source: string,
    traceType: TraceType,
    additionalInfo?: string
    userId?: string
    ip?: string
    traceTypeForExperiment?: TraceType
    webinarId?: string
    email?: string
}

export interface Traces {
    items: Trace[],
    nextPageKey?: string
}

export interface ExperimentMetrics {
    experimentId: string
    variation: string
    source: string
}
